var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPluse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#0065FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_23914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65223 15.4739C9.48105 15.6443 9.25673 15.7441 9.00881 15.75C8.76089 15.75 8.53658 15.656 8.37129 15.4856C8.20011 15.3094 8.10566 15.0862 8.10566 14.8453L8.11747 9.84595L3.1531 9.82833C2.90518 9.82833 2.68087 9.70496 2.52149 9.56397C2.36802 9.3936 2.25586 9.16449 2.25586 8.92363C2.25586 8.68277 2.35031 8.45366 2.52149 8.28329C2.69268 8.11292 2.92879 8.01306 3.17081 8.01306L8.12927 8.03655L8.14698 3.14295C8.14698 2.90796 8.24143 2.67298 8.41261 2.50261C8.5838 2.33225 8.81401 2.25 9.05603 2.25C9.55188 2.25 9.95918 2.64948 9.95918 3.14883L9.94147 8.0483L14.894 8.0953C15.384 8.13642 15.7559 8.5359 15.75 9.00587C15.7441 9.47585 15.3722 9.86358 14.8999 9.89883L9.91786 9.8812V14.8336C9.91786 15.0744 9.82342 15.3094 9.65223 15.4798V15.4739Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_23914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    transform: "translate(2.25 2.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluse);
export default __webpack_public_path__ + "static/media/Pluse.a73bfddf6376aad0f39fc24bb5e296ee.svg";
export { ForwardRef as ReactComponent };